import React from 'react'

const InnerLeadBanner = (props) => {
  return (
    <>
     {/* <!-- Hero Area Start--> */}
        <div class="slider-area ">
        <div class="single-slider section-overly slider-height2 d-flex align-items-center" style={{background: "url('../assets/img/hero/about.jpg')", backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}} data-background="">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="hero-cap text-center">
                            <h2>{props.title}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        {/* <!-- Hero Area End --> */}
    </>
  )
}

export default InnerLeadBanner